import { render, staticRenderFns } from "./CustomPaymentIBD2.vue?vue&type=template&id=3f6b2272&scoped=true&"
import script from "./CustomPaymentIBD2.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentIBD2.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentIBD2.vue?vue&type=style&index=0&id=3f6b2272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b2272",
  null
  
)

export default component.exports